const today = {
    date_and_time: "Date and Time",
    date: "Date",
    time: "Time",
};

const app = {
    id: "Id",
    title: "Name",
    url: "Url",
    logo_url: "Logo Url",
    version: "Version",
    project_id: "Project Id",
    created: "Created",
    updated: "Updated",
};

const account = {
    id: "Id",
    status: "Status",
    name: "Name",
    website: "Website",
    ["branding.primary"]: "Branding: Primary",
    ["branding.secondary"]: "Branding: Secondary",
    ["branding.logo_url"]: "Branding: Logo Url",
    created: "Created",
    updated: "Updated",
};

const user = {
    id: "Id",
    name: "Name",
    first_name: "First Name",
    last_name: "Last Name",
    alias: "Alias",
    email: "Email",
    phone: "Phone",
    image_url: "Image Url",
    ["settings.theme"]: "Settings: Theme",
    ["settings.type"]: "Settings: User Type",
    created: "Created",
    updated: "Updated",
};

const company = {
    name: "Name",
    logo_base64: "Logo",
};

const ed = {
    name: "Name",
    first_name: "First Name",
    last_name: "Last Name",
    name_base64: "Name (image)",
    signature_base64: "Signature",
};

const scott = {
    name: "Name",
    first_name: "First Name",
    last_name: "Last Name",
    name_base64: "Name (image)",
};

export const mergeFields = {
    today: {
        label: "Today",
        fields: today,
    },
    app: {
        label: "App",
        fields: app,
    },
    account: {
        label: "Account",
        fields: account,
    },
    user: {
        label: "User",
        fields: user,
    },
    company: {
        label: "Company",
        fields: company,
    },
    ed: {
        label: "Ed",
        fields: ed,
    },
    scott: {
        label: "Scott",
        fields: scott,
    },
};
